import { FileUploadService } from './../file-upload.service';
import { Component, OnChanges, SimpleChanges, ElementRef,EventEmitter, Input,Output, ViewChild, ViewChildren, QueryList, AfterViewInit, Renderer2, NgZone, ChangeDetectorRef, output } from '@angular/core';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf.mjs'; // Use legacy build
import { GlobalWorkerOptions, PDFPageProxy, PDFDocumentProxy } from 'pdfjs-dist/legacy/build/pdf.mjs'; // Correct import
import { CommonModule } from '@angular/common';
import html2canvas from 'html2canvas';
import { PDFDocument, degrees } from 'pdf-lib';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';


import { CdkDragDrop,
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  moveItemInArray,
  transferArrayItem, } from '@angular/cdk/drag-drop';

interface IPdfFile {
  pdf: PDFDocumentProxy; // Holds the loaded PDF document
  file: File;            // Stores the original file object
  rotate: number;        // Rotation angle (default 0)
  rotatePages: { [page: number]: number }; 
  zoom: number;
}
interface IPdfFileWithRemove extends IPdfFile {
  removedPages?: number[];
}
@Component({
  selector: 'app-pdf-area-selector',
  standalone: true,
  imports: [CommonModule, CdkDropListGroup, CdkDropList, CdkDrag,FormsModule],
  templateUrl: './pdf-area-selector.component.html',
  styleUrls: ['./pdf-area-selector.component.css']
})
export class PdfAreaSelectorComponent implements AfterViewInit {
  @Input() file!: File;
  @Input() files: File[] = [];
  @Input() newfiles: File[] = [];
  
  fileType: string = ''; 
  imageUrl: string = ''; 
  fileName: string = ''; 
  @Input() webUrl!: string;
  isMultiplefiles:Boolean=false;
  zoomedFile: IPdfFile | null = null;
  zoomScale: number = .5;
  currentPage: number = 1;
  totalPages: number = 1;
  zoomedFileIndex: number = 1;

  @Output() updatedData = new EventEmitter<{ files: File[]; pageOrders: number[][] }>();
  @Output() updatedFiles = new EventEmitter<File[]>(); // Emit only files
  @Output() allFilesRemoved = new EventEmitter<void>(); // Notify parent
  pdfFiles: PDFDocumentProxy[] = [];
  isFirstUpload = true;
  @ViewChild('zoomCanvas', { static: false }) zoomCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('popupContainer', { static: false }) popupContainer!: ElementRef;
  selectedAreas: Array<{ x: number, y: number, width: number, height: number }> = [];
  @ViewChildren('canvasElement') canvasElements!: QueryList<ElementRef<HTMLCanvasElement>>;
  @ViewChildren('overlayElement') overlayElements!: QueryList<ElementRef<HTMLDivElement>>;
  @ViewChild('pdfViewer', { static: false }) pdfViewer!: ElementRef<HTMLDivElement>;

  pageNumbers: number[] = [];
   filePageNumbers: number[][] = [];
 // filePageNumbers: { [key: number]: number[] } = {};
  emptyCanvases: boolean[] = [];
   pFiles: IPdfFile[] = [];
  hoverIndex: number = -1;  // Track hovered file index
  


  constructor(private renderer: Renderer2, private ngZone: NgZone, private cdr: ChangeDetectorRef,private fileUploadService: FileUploadService) {}

  
  flushAllArrays() {
    this.pFiles = [];
    this.files = [];
    this.filePageNumbers = [];
  
  }

  

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.pFiles, event.previousIndex, event.currentIndex);
      moveItemInArray(this.files, event.previousIndex, event.currentIndex);
      moveItemInArray(this.filePageNumbers, event.previousIndex, event.currentIndex);
  
      // Emit the updated data
      this.updatedData.emit({ files: this.files, pageOrders: this.filePageNumbers });
      this.updatedFiles.emit(this.files);
    }
  }
   
  
  
  ngAfterViewInit(): void {
    GlobalWorkerOptions.workerSrc = 'assets/pdf.worker.min.mjs';
    this.popupContainer?.nativeElement?.focus();
    if(this.isFirstUpload )
    {
    if (this.files.length > 0 && !this.files[0].type.startsWith("image/"))  {
      this.isMultiplefiles=true;
     
      this.loadMultiplePDFs(this.files);
    } else if (this.file) {
      this.processFile(this.file, 0);
    }
    this.isFirstUpload=false;
  }

  }
  ngOnChanges(changes: SimpleChanges): void {

    
    if(!this.isFirstUpload )
    {
    if (changes['newfiles'] && this.newfiles.length > 0) {
    
      this.isMultiplefiles = true;
      this.loadMultiplePDFsForNewAddedFile(this.newfiles); 
      //this.addFiles(this.newfiles); // Load PDFs when files update
    } 
  }
    // else if (changes['file'] && this.file) {
    //   console.log('Single file updated:', this.file);
    //   //this.processFile(this.file, 0);  // Process a single PDF file
    // }
  }
  async processFile(file: File, index: number): Promise<void> {
    const fileType = file.type;
    this.imageUrl = this.fileTypeToImageMap[fileType];
    
    this.fileName = file.name;
    if(this.fileName=='web.png')
    {
     
      this.imageUrl='assets/images/Web.svg';
    }

    // Mark for check to avoid ExpressionChangedAfterItHasBeenCheckedError
    this.cdr.detectChanges();

    if (fileType === 'application/pdf') {
      this.fileType = 'application/pdf';
      const fileURL = URL.createObjectURL(file);
      await this.loadPdf(fileURL, index);
      this.renderPages();
    } 
    else if (fileType === 'application/image' && this.fileName!='web.png')
    {
      const fileURL = URL.createObjectURL(file);
      this.fileType = 'image';
      this.renderImage(fileURL, index);
    }
    else {
      if (this.imageUrl) {
        this.fileType = 'image';
        this.renderImage(this.imageUrl, index);
      }
       else {
        console.error('Unsupported file type:', fileType);
      }
    }
  }
  async loadMultiplePDFsForNewAddedFile(files: File[]): Promise<void> {
    // Track the starting index for new files
    let startingIndex = this.pFiles.length;  

    for (const file of files) {
        try {
            const fileURL = URL.createObjectURL(file);
            const pdf = await pdfjsLib.getDocument(fileURL).promise;
            this.fileType = file.type;
            const fileIndex = startingIndex++;  
            this.filePageNumbers[fileIndex] = Array.from({ length: pdf.numPages }, (_, i) => i + 1);
            const pageRotations = Array.from({ length: pdf.numPages }, () => 0); 
            // Create PdfFile object
            const pdfFile: IPdfFile = {
                pdf,  // PDFDocumentProxy instance
                file, // Original file
                rotate: 0 ,// Default rotation
                rotatePages:pageRotations,
                zoom: 1  
            };

            this.pFiles.push(pdfFile); // Store PdfFile object
            this.files = [...this.files, file]; // Update files array
            this.updatedData.emit({ files: this.files, pageOrders: this.filePageNumbers });
            this.updatedFiles.emit(this.files);
            // Store page numbers for this PDF at the correct index
          
            
        } catch (error) {
            console.error('Error loading PDF:', error);
        }
    }

    this.cdr.detectChanges();
    // Trigger rendering only for the new files
    this.renderPagesForFiles(this.pFiles);
   // this.addFiles(this.newfiles); 
}
  async loadMultiplePDFs(files: File[]): Promise<void> {
    // Track the starting index for new files
    let startingIndex = this.pFiles.length;  

    for (const file of files) {
        try {
            const fileURL = URL.createObjectURL(file);
            const pdf = await pdfjsLib.getDocument(fileURL).promise;
            this.fileType = file.type;
  // Store page numbers for this PDF at the correct index
           const fileIndex = startingIndex++;  
           this.filePageNumbers[fileIndex] = Array.from({ length: pdf.numPages }, (_, i) => i + 1);
           const pageRotations = Array.from({ length: pdf.numPages }, () => 0); 
            // Create PdfFile object
            const pdfFile: IPdfFile = {
                pdf,  // PDFDocumentProxy instance
                file, // Original file
                rotate: 0, // Default rotation
                rotatePages:pageRotations,
                zoom: 1  
            };

            this.pFiles.push(pdfFile); // Store PdfFile object
          
            
        } catch (error) {
            console.error('Error loading PDF:', error);
        }
    }

    this.cdr.detectChanges();
    // Trigger rendering only for the new files
    this.renderPagesForFiles(this.pFiles);
   // this.addFiles(this.newfiles); 
}

  // async loadMultiplePDFs(files: File[]): Promise<void> {
  //    // Define pdfFiles inside the function
  //   //let filePageNumbers: { [key: number]: number[] } = {}; // Store page numbers for each file
  //   let pnum: number = 0;
  
  //   for (const file of files) {
  //     try {
  //       const fileURL = URL.createObjectURL(file);
  //       const pdf = await pdfjsLib.getDocument(fileURL).promise;
  //       this.fileType=file.type;
  
  //       // Create PdfFile object
  //       const pdfFile: IPdfFile = {
  //         pdf,  // PDFDocumentProxy instance
  //         file, // Original file
  //         rotate: 0 // Default rotation
  //       };
  
  //       this.pFiles.push(pdfFile); // Store PdfFile object
  
  //       // Store page numbers for this PDF
  //       const pageNumbers = Array.from({ length: pdf.numPages }, (_, i) => i + 1);
  //       this.filePageNumbers[pnum] = [...pageNumbers];
        
      
  //       pnum++;
  //     } catch (error) {
  //       console.error('Error loading PDF:', error);
  //     }
  //   }
    
  //   this.cdr.detectChanges();
  //   // After loading all PDFs, trigger rendering
  //   this.renderPagesForFiles(this.pFiles);
  // }
  
  // getFilePages(index: number): number {
  //   return this.filePageNumbers[index]?.length || 0;
  // }
  getFilePages(index: number): number {
    const file = this.pFiles[index] as IPdfFileWithRemove;
    const total = file?.pdf?.numPages || 0;
    const removed = file?.removedPages?.length || 0;
    return total - removed;
  }
 
    
  
  async loadPdf(fileURL: string, index: number): Promise<void> {
    try {
      this.pdfFiles = []; // Clear previous PDFs if necessary
      const pdf = await pdfjsLib.getDocument(fileURL).promise;
      this.pdfFiles.push(pdf); // Add the single PDF to the array
      this.pageNumbers = Array.from({ length: pdf.numPages }, (_, i) => i + 1);
    } catch (error) {
      console.error('Error loading PDF:', error);
    }
  }

  async renderPages(): Promise<void> {
    await new Promise<void>(resolve => setTimeout(resolve, 0));

    this.canvasElements.forEach((canvasElement, pageIndex) => {
      const canvas = canvasElement.nativeElement;
      const context = canvas.getContext('2d');
      const overlay = this.overlayElements.toArray()[pageIndex].nativeElement;
      

      // Calculate which PDF document the page belongs to
      let cumulativePageCount = 0;
      let pdfFile: PDFDocumentProxy | null = null;
      let pageInPdf = 0;

      // Determine which PDF document and page we're rendering
      for (let i = 0; i < this.pdfFiles.length; i++) {
        const pdf = this.pdfFiles[i];
        const numPages = pdf.numPages;
        this.fileUploadService.changenumberofPdfPages(numPages);
        // if (pageIndex >= cumulativePageCount && pageIndex < cumulativePageCount + numPages) {
        //   pdfFile = pdf;
        //   pageInPdf = pageIndex - cumulativePageCount + 1; // 1-based index for getPage()
        //   break;
        // }

        
        if (pageIndex < cumulativePageCount + numPages) {
          pdfFile = pdf;
          pageInPdf = pageIndex - cumulativePageCount + 1; // 1-based index for getPage()
          break;
        }

        cumulativePageCount += numPages;
      }

      if (pdfFile) {
        pdfFile.getPage(pageInPdf).then(async (page: PDFPageProxy) => {
          const viewport = page.getViewport({ scale: 0.2 });

          if (context) {
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            overlay.style.width = `${viewport.width}px`;
            overlay.style.height = `${viewport.height}px`;

            context.fillStyle = '#f0f0f0';
            context.fillRect(0, 0, canvas.width, canvas.height);

            const renderContext = {
              canvasContext: context,
              viewport: viewport,
            };

            await page.render(renderContext).promise;

            this.renderer.listen(overlay, 'click', (event) => this.onOverlayClick(event, overlay));
          } else {
            console.error('Canvas context is null');
          }
        });
      } else {
        console.error('PDF file not found for page index:', pageIndex);
       
      }
    });
  }
  renderPagesForFiles(pdfFiles: IPdfFile[]): void {
    setTimeout(() => {
      pdfFiles.forEach((pdfFile, fileIndex) => {
        const canvasElement = this.canvasElements.toArray()[fileIndex]?.nativeElement;
        const overlayElement = this.overlayElements.toArray()[fileIndex]?.nativeElement;
  
        if (!canvasElement || !overlayElement) return;
  
        const context = canvasElement.getContext('2d');
        if (!context) return;
  
        const pageNumber = 1; // ✅ Always show page 1 in main preview
  
        pdfFile.pdf.getPage(pageNumber).then((page: PDFPageProxy) => {
          const fileRotation = pdfFile.rotate || 0;
          const pageRotation = pdfFile.rotatePages?.[pageNumber - 1] || 0;
          const combinedRotation = (fileRotation + pageRotation) % 360;
  
          const viewport = page.getViewport({ scale: 0.2, rotation: combinedRotation });
  
          canvasElement.width = viewport.width;
          canvasElement.height = viewport.height;
          overlayElement.style.width = `${viewport.width}px`;
          overlayElement.style.height = `${viewport.height}px`;
  
          context.clearRect(0, 0, canvasElement.width, canvasElement.height);
          context.save();
          context.translate(canvasElement.width / 2, canvasElement.height / 2);
          context.rotate((combinedRotation * Math.PI) / 180);
          context.translate(-canvasElement.width / 2, -canvasElement.height / 2);
  
          page.render({ canvasContext: context, viewport }).promise.then(() => {
            context.restore();
          });
  
          this.renderer.listen(overlayElement, 'click', (event) =>
            this.onOverlayClick(event, overlayElement)
          );
        });
      });
    }, 0);
  }
  
  
  
  renderImage(imageUrl: string, index: number): void {
    const img = new Image();
    img.onload = () => {
      this.ngZone.runOutsideAngular(() => {
        try {
          const canvasElement = this.canvasElements.toArray()[index].nativeElement;
          const context = canvasElement.getContext('2d');

          if (!context) {
            console.error('Failed to get 2D context from canvas.');
            return;
          }

          canvasElement.width = img.width;
          canvasElement.height = img.height;
          

          context.fillStyle = '#f0f0f0';
          context.fillRect(0, 0, canvasElement.width, canvasElement.height);

          context.drawImage(img, 0, 0, img.width, img.height);

          this.ngZone.run(() => {
            this.cdr.detectChanges(); // Trigger change detection if needed
          });
        } catch (error) {
          console.error('Error while rendering image:', error);
        }
      });
    };

    img.onerror = () => {
      console.error('Failed to load image from URL:', imageUrl);
    };

    img.src = imageUrl;
  }

  onOverlayClick(event: MouseEvent, overlay: HTMLElement) {
    this.clearPreviousSelections(overlay);

    const rect = overlay.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    const width = 10;
    const height = 10;

    this.addSelectedArea(x, y, width, height, overlay);
  }

  clearPreviousSelections(overlay: HTMLElement) {
    const children = overlay.children;
    while (children.length > 0) {
      this.renderer.removeChild(overlay, children[0]);
    }
  }

  addSelectedArea(x: number, y: number, width: number, height: number, overlay: HTMLElement) {
    const area = { x, y, width, height };
    this.selectedAreas.push(area);

    const areaElement = this.renderer.createElement('div');
    this.renderer.addClass(areaElement, 'selected-area');
    this.renderer.setStyle(areaElement, 'left', `${x}px`);
    this.renderer.setStyle(areaElement, 'top', `${y}px`);
    this.renderer.setStyle(areaElement, 'width', `${width}px`);
    this.renderer.setStyle(areaElement, 'height', `${height}px`);
    this.renderer.setStyle(areaElement, 'position', 'absolute');
    this.renderer.appendChild(overlay, areaElement);

  
  }
  
  addFiles(newFiles: any[]) {
    if (newFiles && newFiles.length > 0) {
      // Ensure all files are added to the arrays
      this.files = [...this.files, ...newFiles]; // Add new files
      this.pFiles = [...this.pFiles, ...newFiles]; // Add to parallel array
      this.filePageNumbers = [...this.filePageNumbers, ...newFiles.map(() => [1])];
  
      // Emit updated data
      this.updatedData.emit({ files: this.files, pageOrders: this.filePageNumbers });
      this.updatedFiles.emit(this.files);
    }
  }
  
  
  onDrop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  
      // Sync changes with files and page numbers
      const updatedPFiles = [...this.pFiles];
      const updatedFiles = [...this.files];
      const updatedPageNumbers = [...this.filePageNumbers];
  
      moveItemInArray(updatedPFiles, event.previousIndex, event.currentIndex);
      moveItemInArray(updatedFiles, event.previousIndex, event.currentIndex);
      moveItemInArray(updatedPageNumbers, event.previousIndex, event.currentIndex);
  
      this.pFiles = updatedPFiles;
      this.files = updatedFiles;
      this.filePageNumbers = updatedPageNumbers;
  
      // Emit the updated data
      this.updatedData.emit({ files: this.files, pageOrders: this.filePageNumbers });
      this.updatedFiles.emit(this.files);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }
  
  
  checkCanvasIsEmpty(): boolean {
    if (!this.canvasElements || this.canvasElements.length === 0) {
      return true; // If no canvas exists, consider it empty
    }

    return this.canvasElements.toArray().every(canvas => {
      const context = canvas.nativeElement.getContext('2d');
      if (!context) return true; // If canvas context is missing, assume empty

      const imageData = context.getImageData(0, 0, canvas.nativeElement.width, canvas.nativeElement.height);
      return imageData.data.every(value => value === 0); // Returns true if all pixels are empty
    });
  }
  // rotateAndSavePDF(file: File, rotationAngle: number): Promise<File | null> {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  
  //     reader.onload = () => {
  //       if (!(reader.result instanceof ArrayBuffer)) {
  //         console.error("Invalid ArrayBuffer result");
  //         reject(null);
  //         return;
  //       }
  
  //       const arrayBuffer = reader.result.slice(0); // Clone buffer to avoid detachment issues
  
  //       PDFDocument.load(arrayBuffer)
  //         .then(pdfDoc => {
  //           const pages = pdfDoc.getPages();
  
  //           // Rotate all pages
  //           pages.forEach(page => page.setRotation(degrees(rotationAngle)));
  
  //           // Save modified PDF
  //           return pdfDoc.save();
  //         })
  //         .then(modifiedPdfBytes => {
  //           const rotatedFile = new File([modifiedPdfBytes], `${file.name}`, { 
  //             type: "application/pdf" 
  //           });
  
  //           resolve(rotatedFile);
  //         })
  //         .catch(error => {
  //           console.error("Error processing PDF:", error);
  //           reject(null);
  //         });
  //     };
  
  //     reader.onerror = () => {
  //       console.error("Error reading the file");
  //       reject(null);
  //     };
  
  //     reader.readAsArrayBuffer(file);
  //   });
  // }
 async rotateAndSavePDF(file: File, rotationAngle: number): Promise<File | null> {
  try {
    // Read file
    const arrayBuffer = await file.arrayBuffer();

    // Load PDF
    const pdfDoc = await PDFDocument.load(arrayBuffer);

    const pages = pdfDoc.getPages();

    // Rotate all pages
    pages.forEach(page => {
      page.setRotation(degrees(rotationAngle));
    });

    // Save modified PDF
    const modifiedPdfBytes = await pdfDoc.save();

    // ✅ FIX: Create safe Uint8Array copy
    const safeBytes = new Uint8Array(modifiedPdfBytes);

    // Create file safely
    const rotatedFile = new File(
      [safeBytes],
      file.name,
      { type: "application/pdf" }
    );

    return rotatedFile;

  } catch (error) {
    console.error("Error processing PDF:", error);
    return null;
  }
}
  rotateFile(index: number) {
    this.pFiles[index].rotate = (this.pFiles[index].rotate + 90) % 360;
  
    this.rotateAndSavePDF(this.files[index], this.pFiles[index].rotate).then((rotatedFile) => {
      if (rotatedFile) {
  
        // Update `files` immutably
        this.files = [...this.files.slice(0, index), rotatedFile, ...this.files.slice(index + 1)];
        
        // Update `pFiles` immutably to trigger change detection
        const updatedPFiles = [...this.pFiles];
        updatedPFiles[index] = { ...updatedPFiles[index], file: rotatedFile };
        //this.pFiles = updatedPFiles;
  
        // Emit updated files
        this.updatedFiles.emit(this.files);
      }
    });
  }
 
  rotateZoomedPage(): void {
    if (!this.zoomedFile) return;
  
    const currentIndex = this.currentPage - 1;
    this.zoomedFile.rotatePages[currentIndex] =
      (this.zoomedFile.rotatePages[currentIndex] + 90) % 360;
  
    const originalFile = this.zoomedFile.file;
  
    const removed = (this.zoomedFile as IPdfFileWithRemove).removedPages || [];
    const totalPages = this.zoomedFile.pdf.numPages;
    const visiblePages = [...Array(totalPages).keys()].map(i => i + 1).filter(p => !removed.includes(p));
    const pageToRender = visiblePages[0] || 1;

    const actualVisiblePages = this.getActualVisiblePages(this.zoomedFile);
     const pageToRotate = actualVisiblePages[this.currentPage - 1];
  
    this.rotateSinglePageAndSavePDF(this.zoomedFile.file, pageToRotate, 90)
      .then((rotatedFile) => {
        if (!rotatedFile) {
          console.error("Rotation failed.");
          return;
        }
  
        const updatedPFiles = [...this.pFiles];
        if (!this.zoomedFile) return;
        this.zoomedFile.file = rotatedFile;
        updatedPFiles[this.zoomedFileIndex] = { ...this.zoomedFile };
  
        this.pFiles = updatedPFiles;
        this.files = this.pFiles.map(p => p.file);
        this.updatedFiles.emit(this.files);
        
        this.renderZoomedCanvas();
        this.cdr.detectChanges();
        this.renderSpecificPage(this.pFiles[this.zoomedFileIndex], this.zoomedFileIndex, pageToRender);
      })
      .catch(error => {
        console.error("Failed to rotate page:", error);
      });
  }
  
  
  // rotateSinglePageAndSavePDF(file: File, pageNumberToRotate: number, rotationAngle: number): Promise<File | null> {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  
  //     reader.onload = () => {
  //       if (!(reader.result instanceof ArrayBuffer)) {
  //         console.error("Invalid ArrayBuffer result");
  //         reject(null);
  //         return;
  //       }
  
  //       const arrayBuffer = reader.result.slice(0); // Clone to avoid detachment
  
  //       PDFDocument.load(arrayBuffer)
  //         .then(async pdfDoc => {
  //           const pages = pdfDoc.getPages();
  
  //           if (pageNumberToRotate < 1 || pageNumberToRotate > pages.length) {
  //             console.error("Invalid page number");
  //             reject(null);
  //             return;
  //           }
  
  //           const targetPage = pages[pageNumberToRotate - 1]; // 0-based index
  //           const currentRotation = targetPage.getRotation().angle;
  //           targetPage.setRotation(degrees((currentRotation + rotationAngle) % 360));
  
  //           const modifiedPdfBytes = await pdfDoc.save();
  
  //           const rotatedFile = new File([modifiedPdfBytes], `${file.name}`, {
  //             type: "application/pdf"
  //           });
  
  //           resolve(rotatedFile);
  //         })
  //         .catch(error => {
  //           console.error("Error processing PDF:", error);
  //           reject(null);
  //         });
  //     };
  
  //     reader.onerror = () => {
  //       console.error("Error reading the file");
  //       reject(null);
  //     };
  
  //     reader.readAsArrayBuffer(file);
  //   });
  // }
  
  async rotateSinglePageAndSavePDF(
  file: File,
  pageNumberToRotate: number,
  rotationAngle: number
): Promise<File | null> {

  try {
    // Read file safely
    const arrayBuffer = await file.arrayBuffer();

    // Load PDF
    const pdfDoc = await PDFDocument.load(arrayBuffer);

    const pages = pdfDoc.getPages();

    // Validate page number
    if (
      pageNumberToRotate < 1 ||
      pageNumberToRotate > pages.length
    ) {
      console.error("Invalid page number");
      return null;
    }

    // Get target page
    const targetPage = pages[pageNumberToRotate - 1];

    // Get current rotation
    const currentRotation =
      targetPage.getRotation().angle;

    // Apply rotation
    targetPage.setRotation(
      degrees((currentRotation + rotationAngle) % 360)
    );

    // Save PDF
    const modifiedPdfBytes =
      await pdfDoc.save();

    // ✅ FIX: Create safe copy (important)
    const safeBytes =
      new Uint8Array(modifiedPdfBytes);

    // Create new file
    const rotatedFile = new File(
      [safeBytes],
      file.name,
      { type: "application/pdf" }
    );

    return rotatedFile;

  } catch (error) {
    console.error("Error processing PDF:", error);
    return null;
  }
}
//  removePage(pageNumber: number): void {
//   const fileIndex = this.zoomedFileIndex;
//   const pdfFile = this.pFiles[fileIndex] as IPdfFileWithRemove;

//   if (!pdfFile || !pdfFile.file) return;

//   // Initialize removedPages if needed
//   if (!Array.isArray(pdfFile.removedPages)) {
//     pdfFile.removedPages = [];
//   }

//   const totalPages = pdfFile.pdf?.numPages || 0;
//   const removed = pdfFile.removedPages;

//   // Calculate actual page number
//   const visiblePages = [...Array(totalPages).keys()]
//     .map(i => i + 1)
//     .filter(p => !removed.includes(p));

//   const actualPageNumber = visiblePages[pageNumber - 1];
//   if (actualPageNumber === undefined) return;

//   // Mark page as removed
//   if (!removed.includes(actualPageNumber)) {
//     removed.push(actualPageNumber);
//   }

//   // Clean rotation if exists
//   if (pdfFile.rotatePages && pdfFile.rotatePages[actualPageNumber - 1] !== undefined) {
//     delete pdfFile.rotatePages[actualPageNumber - 1];
//   }

//   const updatedVisiblePages = this.getActualVisiblePages(pdfFile);

//   if (updatedVisiblePages.length === 0) {
//     // All pages removed
//     this.pFiles.splice(fileIndex, 1);
//     this.files.splice(fileIndex, 1);
//     this.zoomedFile = null;
//     this.zoomedFileIndex = -1;
//     this.closeZoom();
//     return;
//   }

//   const reader = new FileReader();
//   reader.onload = async () => {
//     if (!(reader.result instanceof ArrayBuffer)) return;

//     const arrayBuffer = reader.result.slice(0);
//     const originalDoc = await PDFDocument.load(arrayBuffer);
//     const total = originalDoc.getPageCount();

//     const pagesToKeep: number[] = [];
//     for (let i = 0; i < total; i++) {
//       if (!removed.includes(i + 1)) {
//         pagesToKeep.push(i);
//       }
//     }

//     const newPdf = await PDFDocument.create();
//     const copiedPages = await newPdf.copyPages(originalDoc, pagesToKeep);
//     copiedPages.forEach(page => newPdf.addPage(page));
//     const newBytes = await newPdf.save();

//     const newFile = new File([newBytes], pdfFile.file.name, { type: 'application/pdf' });

//     // Update file
//     pdfFile.file = newFile;
//     this.files[fileIndex] = newFile;
//     this.zoomedFile = pdfFile;
//     this.totalPages = updatedVisiblePages.length;

//     // Fix current page index
//     if (this.currentPage > this.totalPages) {
//       this.currentPage = this.totalPages;
//     }

//     // ✅ Rebuild rotatePages to match remaining visible pages
//     const newRotatePages: Record<number, number> = {};
//     if (pdfFile.rotatePages) {
//       updatedVisiblePages.forEach((pageNum, idx) => {
//         const rotation = pdfFile.rotatePages?.[pageNum - 1];
//         if (rotation !== undefined) {
//           newRotatePages[idx] = rotation;
//         }
//       });
//     }
//     pdfFile.rotatePages = newRotatePages;

//     // ✅ Render next valid page
//     const nextVisiblePage = updatedVisiblePages[0];
//     this.renderSpecificPage(pdfFile, fileIndex, nextVisiblePage);
//     this.renderZoomedCanvasForDeletePage(); // Make sure this respects removed pages
//     this.updatedFiles.emit(this.files);
//     this.cdr.detectChanges();
//   };

//   reader.readAsArrayBuffer(pdfFile.file);
// }
removePage(pageNumber: number): void {

  const fileIndex = this.zoomedFileIndex;
  const pdfFile = this.pFiles[fileIndex] as IPdfFileWithRemove;

  if (!pdfFile || !pdfFile.file) return;

  // Initialize removedPages if needed
  if (!Array.isArray(pdfFile.removedPages)) {
    pdfFile.removedPages = [];
  }

  const totalPages = pdfFile.pdf?.numPages || 0;
  const removed = pdfFile.removedPages;

  // Calculate actual page number
  const visiblePages = [...Array(totalPages).keys()]
    .map(i => i + 1)
    .filter(p => !removed.includes(p));

  const actualPageNumber =
    visiblePages[pageNumber - 1];

  if (actualPageNumber === undefined) return;

  // Mark page as removed
  if (!removed.includes(actualPageNumber)) {
    removed.push(actualPageNumber);
  }

  // Clean rotation if exists
  if (
    pdfFile.rotatePages &&
    pdfFile.rotatePages[actualPageNumber - 1] !== undefined
  ) {
    delete pdfFile.rotatePages[
      actualPageNumber - 1
    ];
  }

  const updatedVisiblePages =
    this.getActualVisiblePages(pdfFile);

  if (updatedVisiblePages.length === 0) {

    // All pages removed
    this.pFiles.splice(fileIndex, 1);
    this.files.splice(fileIndex, 1);

    this.zoomedFile = null;
    this.zoomedFileIndex = -1;

    this.closeZoom();
    return;
  }

  const reader = new FileReader();

  reader.onload = async () => {

    try {

      if (!(reader.result instanceof ArrayBuffer))
        return;

      const arrayBuffer =
        reader.result.slice(0);

      const originalDoc =
        await PDFDocument.load(arrayBuffer);

      const total =
        originalDoc.getPageCount();

      const pagesToKeep: number[] = [];

      for (let i = 0; i < total; i++) {

        if (!removed.includes(i + 1)) {

          pagesToKeep.push(i);

        }

      }

      const newPdf =
        await PDFDocument.create();

      const copiedPages =
        await newPdf.copyPages(
          originalDoc,
          pagesToKeep
        );

      copiedPages.forEach(page =>
        newPdf.addPage(page)
      );

      const newBytes =
        await newPdf.save();

      // ✅ CRITICAL FIX — create clean Uint8Array
      const cleanBytes =
        new Uint8Array(newBytes.length);

      cleanBytes.set(newBytes);

      // Create new File safely
      const newFile = new File(
        [cleanBytes],
        pdfFile.file.name,
        { type: 'application/pdf' }
      );

      // Update file
      pdfFile.file = newFile;
      this.files[fileIndex] = newFile;
      this.zoomedFile = pdfFile;

      this.totalPages =
        updatedVisiblePages.length;

      // Fix current page index
      if (
        this.currentPage >
        this.totalPages
      ) {
        this.currentPage =
          this.totalPages;
      }

      // ✅ Rebuild rotatePages
      const newRotatePages:
        Record<number, number> = {};

      if (pdfFile.rotatePages) {

        updatedVisiblePages.forEach(
          (pageNum, idx) => {

            const rotation =
              pdfFile.rotatePages?.[
                pageNum - 1
              ];

            if (rotation !== undefined) {

              newRotatePages[idx] =
                rotation;

            }

          }
        );

      }

      pdfFile.rotatePages =
        newRotatePages;

      // Render next valid page
      const nextVisiblePage =
        updatedVisiblePages[0];

      this.renderSpecificPage(
        pdfFile,
        fileIndex,
        nextVisiblePage
      );

      this.renderZoomedCanvasForDeletePage();

      this.updatedFiles.emit(
        this.files
      );

      this.cdr.detectChanges();

    }
    catch (error) {

      console.error(
        "Error removing page:",
        error
      );

    }

  };

  reader.readAsArrayBuffer(pdfFile.file);

}

  
  
  
  


  // deletePagesAndSavePDF(file: File, pagesToDelete: number[]): Promise<File | null> {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  
  //     reader.onload = () => {
  //       if (!(reader.result instanceof ArrayBuffer)) {
  //         reject(null);
  //         return;
  //       }
  
  //       const arrayBuffer = reader.result.slice(0);
  
  //       PDFDocument.load(arrayBuffer).then(async (pdfDoc) => {
  //         const totalPages = pdfDoc.getPageCount();
  //         const pagesToKeep: number[] = [];
  
  //         for (let i = 0; i < totalPages; i++) {
  //           if (!pagesToDelete.includes(i + 1)) {
  //             pagesToKeep.push(i); // 0-based
  //           }
  //         }
  
  //         const newPdfDoc = await PDFDocument.create();
  //         const copiedPages = await newPdfDoc.copyPages(pdfDoc, pagesToKeep);
  //         copiedPages.forEach((page) => newPdfDoc.addPage(page));
  
  //         const newPdfBytes = await newPdfDoc.save();
  //         const updatedFile = new File([newPdfBytes], file.name, { type: "application/pdf" });
  //         resolve(updatedFile);
  //       }).catch(reject);
  //     };
  
  //     reader.onerror = () => reject(null);
  //     reader.readAsArrayBuffer(file);
  //   });
  // }
  deletePagesAndSavePDF(
  file: File,
  pagesToDelete: number[]
): Promise<File | null> {

  return new Promise((resolve, reject) => {

    const reader = new FileReader();

    reader.onload = async () => {

      try {

        if (!(reader.result instanceof ArrayBuffer)) {
          reject(null);
          return;
        }

        const arrayBuffer =
          reader.result.slice(0);

        const pdfDoc =
          await PDFDocument.load(arrayBuffer);

        const totalPages =
          pdfDoc.getPageCount();

        const pagesToKeep: number[] = [];

        // Build list of pages to keep
        for (let i = 0; i < totalPages; i++) {

          if (!pagesToDelete.includes(i + 1)) {

            pagesToKeep.push(i); // 0-based index

          }

        }

        const newPdfDoc =
          await PDFDocument.create();

        const copiedPages =
          await newPdfDoc.copyPages(
            pdfDoc,
            pagesToKeep
          );

        copiedPages.forEach(page =>
          newPdfDoc.addPage(page)
        );

        const newPdfBytes =
          await newPdfDoc.save();

        // ✅ CRITICAL FIX — create clean buffer
        const cleanBytes =
          new Uint8Array(
            newPdfBytes.length
          );

        cleanBytes.set(newPdfBytes);

        // Create new File safely
        const updatedFile = new File(
          [cleanBytes],
          file.name,
          { type: "application/pdf" }
        );

        resolve(updatedFile);

      }
      catch (error) {

        console.error(
          "Error deleting pages:",
          error
        );

        reject(null);

      }

    };

    reader.onerror = () => {

      reject(null);

    };

    reader.readAsArrayBuffer(file);

  });

}


  
  
  private getActualVisiblePages(pdfFile: IPdfFileWithRemove): number[] {
    const totalPages = pdfFile.pdf.numPages;
  
    return [...Array(totalPages).keys()]
      .map(i => i + 1)
      .filter(p => !pdfFile.removedPages?.includes(p));
  }
  
  
    
   
  
  renderSpecificPage(pdfFile: IPdfFileWithRemove, fileIndex: number, _pageNumber: number): void {
    const canvasElement = this.canvasElements.toArray()[fileIndex]?.nativeElement;
    const overlayElement = this.overlayElements.toArray()[fileIndex]?.nativeElement;
  
    if (!canvasElement || !overlayElement) {
      console.error('Canvas or overlay element not found for file index:', fileIndex);
      return;
    }
  
    const context = canvasElement.getContext('2d');
    if (!context) {
      console.error('Canvas context is null');
      return;
    }
  
    const totalPages = pdfFile.pdf.numPages;
  
    // 👇 Get first visible (non-removed) page
    const removed = pdfFile.removedPages || [];
    const visiblePages = [...Array(totalPages).keys()].map(i => i + 1).filter(p => !removed.includes(p));
  
    if (visiblePages.length === 0) {
      console.warn('No visible pages available.');
      return;
    }
  
    //const pageNumber = visiblePages[0]; // ✅ First visible page
    const pageNumber = _pageNumber;
    pdfFile.pdf.getPage(pageNumber).then((page: PDFPageProxy) => {
      const pageRotation = pdfFile.rotatePages?.[pageNumber - 1] || 0;
      const viewport = page.getViewport({ scale: 0.2, rotation: pageRotation });
  
      canvasElement.width = viewport.width;
      canvasElement.height = viewport.height;
      overlayElement.style.width = `${viewport.width}px`;
      overlayElement.style.height = `${viewport.height}px`;
  
      context.clearRect(0, 0, canvasElement.width, canvasElement.height);
  
      page.render({ canvasContext: context, viewport }).promise.then(() => {
        // Page rendered
      });
  
      this.renderer.listen(overlayElement, 'click', (event) =>
        this.onOverlayClick(event, overlayElement)
      );
  
    }).catch((error) => {
      console.error('Error rendering specific page:', error);
    });
  }
  
  
  
  
  
  zoomFile(index: number): void {
    this.zoomedFileIndex = index;
  
    // Get the file (ensure it's of type IPdfFileWithRemove)
    const freshCopy: IPdfFileWithRemove = this.pFiles[index];
    if (!freshCopy) return;
  
    // Deep clone the file and its properties, including rotatePages
    this.zoomedFile = {
      ...freshCopy,
      rotatePages: { ...(freshCopy.rotatePages || {}) },  // Deep clone rotatePages
    };
  
    // Initialize properties for zooming functionality
    this.currentPage = 1;
    this.zoomScale = 0.5;
  
    // Trigger change detection if needed
    this.cdr.detectChanges();
  
    // Get the PDF document from the zoomed file
    const pdf = this.zoomedFile.pdf;
  
    // Get the total number of pages from the PDF
    pdf.getPage(1).then(() => {
      // Calculate total pages, excluding the removed pages
      const removedPagesCount = freshCopy.removedPages?.length || 0;
      this.totalPages = pdf.numPages - removedPagesCount;
  
      // Render zoomed canvas for delete page functionality
      this.renderZoomedCanvasForDeletePage();
    });
  }
  
  goToPreviousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.renderZoomedCanvasForDeletePage(); // ✅ Fix: use correct rendering method
    }
  }
  
  // goToPreviousPage(): void {
  //   if (this.currentPage > 1) {
  //     this.currentPage--;
  //     this.renderZoomedCanvas();
  //   }
  // }
  
  goToNextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.renderZoomedCanvasForDeletePage();
    }
  }
  
  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.renderZoomedCanvasForDeletePage();
    }
  }
  
  closeZoom(): void {
    this.zoomedFile = null;
    this.cdr.detectChanges();
  }
  renderZoomedCanvasForDeletePage(): void {
    if (!this.zoomedFile) return;
  
    const pdf = this.zoomedFile.pdf;
    const removedPages = (this.zoomedFile as IPdfFileWithRemove).removedPages || [];
    const visiblePages = Array.from({ length: pdf.numPages }, (_, i) => i + 1).filter(p => !removedPages.includes(p));
  
    if (visiblePages.length === 0) return;
  
    const actualPageNumber = visiblePages[this.currentPage - 1]; // map from visible index to actual page
  
    const fileRotation = this.zoomedFile.rotate || 0;
    const pageRotation = this.zoomedFile.rotatePages?.[actualPageNumber - 1] || 0;
    const rotationAngle = (fileRotation + pageRotation) % 360;
  
    pdf.getPage(actualPageNumber).then((page) => {
      const viewport = page.getViewport({
        scale: this.zoomScale,
        rotation: rotationAngle
      });
  
      const canvas: HTMLCanvasElement = this.zoomCanvas.nativeElement;
      const context = canvas.getContext('2d')!;
      canvas.width = viewport.width;
      canvas.height = viewport.height;
  
      canvas.style.width = `${viewport.width}px`;
      canvas.style.height = `${viewport.height}px`;
  
      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };
  
      page.render(renderContext);
    });
  }
  
  
  renderZoomedCanvas(): void {
    if (!this.zoomedFile) return;
  
    const pdf = this.zoomedFile.pdf;
  
    const fileRotation = this.zoomedFile.rotate || 0;
    const pageRotation = this.zoomedFile.rotatePages?.[this.currentPage - 1] || 0;
    const rotationAngle = (fileRotation + pageRotation) % 360;
  
    pdf.getPage(this.currentPage).then((page) => {
      const viewport = page.getViewport({ 
        scale: this.zoomScale,
        rotation: rotationAngle
      });
  
      const canvas: HTMLCanvasElement = this.zoomCanvas.nativeElement;
      const context = canvas.getContext('2d')!;
      canvas.width = viewport.width;
      canvas.height = viewport.height;
  
      canvas.style.width = `${viewport.width}px`;
      canvas.style.height = `${viewport.height}px`;
  
      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };
  
      page.render(renderContext);
    });
  }
  
  
  zoomIn(): void {
    
    this.zoomScale += 0.15;
    
    this.cdr.detectChanges();
    this.renderZoomedCanvas();
  }
  
  zoomOut(): void {
    if (this.zoomScale > 0.25) {
      this.zoomScale -= 0.15;
      this.cdr.detectChanges();
      this.renderZoomedCanvas();
    }
  }
  //  rotateAndSavePDF(file: File, rotationAngle: number): Promise<File | null> {
  //   const reader = new FileReader();
  
  //   return new Promise((resolve, reject) => {
  //     reader.onload = async function () {
  //       try {
  //         const arrayBuffer = reader.result as ArrayBuffer;
  //         const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise as PDFDocumentProxy;
  
  //         // Load the PDF in pdf-lib for modification
  //         const pdfDoc = await PDFDocument.load(arrayBuffer);
  //         const pages = pdfDoc.getPages();
  
  //         // Apply rotation to each page
  //         pages.forEach(page => page.setRotation(degrees(rotationAngle)));
  
  //         // Save modified PDF
  //         const modifiedPdfBytes = await pdfDoc.save();
  
  //         // Create a new File object
  //         const rotatedFile = new File([modifiedPdfBytes], `rotated_${file.name}`, { type: "application/pdf" });
  
  //         resolve(rotatedFile);
  //       } catch (error) {
  //         console.error('Error processing PDF:', error);
  //         reject(null);
  //       }
  //     };
  
  //     reader.onerror = () => reject(null);
  //     reader.readAsArrayBuffer(file);
  //   });
  // }
  removeFile(index: number) {
    this.pFiles.splice(index, 1);
    this.files.splice(index, 1);
  
    // 🔄 Keep files1 and files2 in sync
    // if (this.files1) {
    //   this.files1.splice(index, 1);
    // }
    // if (this.files2) {
    //   this.files2.splice(index, 1);
    // }
  
    // Emit updated files to parent
    this.updatedFiles.emit(this.files);  // Make sure parent updates its arrays too
  
    // Notify parent if all files are removed
    if (this.pFiles.length === 0) {
      this.allFilesRemoved.emit();
    }
  }
  
  // rotateFile(index: number) {
  //   // Update rotation metadata
  //   this.pFiles[index].rotate = (this.pFiles[index].rotate + 90) % 360;
  
  //   // Apply rotation and replace the actual file
  //   this.rotateAndSavePDF(this.files[index], this.pFiles[index].rotate)
  //     .then((rotatedFile) => {
  //       if (rotatedFile) {
  //         console.log("Rotated file generated:", rotatedFile);
          
  //         // Update the uploaded file with the rotated version
  //         this.files[index] = rotatedFile;
  //       }
  //     });
  // }
  
  fileTypeToImageMap: { [key: string]: string } = {
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'assets/images/Word.svg',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'assets/images/Excel.svg',
    'image/jpeg': 'assets/images/jpg-to-pdf.svg',
    'image/png': 'assets/images/jpg-to-pdf.svg',
    'image/webp': 'assets/images/jpg-to-pdf.svg',
    'image/svg+xml': 'assets/images/jpg-to-pdf.svg',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'assets/images/pptx1.svg',
    'application/vnd.ms-powerpoint': 'assets/images/pptx1.svg',
  };

  

 
}
